import { GradeKey } from "@/enums/connectGrades";
import { isValidSubjectKey, SubjectKey } from "@/enums/connectSubjects";
import { CORE_TO_CONNECT_GRADE } from "@/enums/coreGrades";

export const DEFAULT_MILE_RANGE = 200;

export interface PreferenceFilterInput {
  grades: number[];
  subjects: string[];
  location: string;
  milesWithin: number | null;
}

export interface PreferenceFilters {
  address: string;
  radius: number;
  grades: GradeKey[];
  subjects: SubjectKey[];
}

const resolveRadius = (milesWithin: number | null): number => {
  if (milesWithin !== null && Number.isFinite(milesWithin) && milesWithin > 0) {
    return milesWithin;
  }

  return DEFAULT_MILE_RANGE;
};

export const convertPreferencesToFilters = (
  preference: PreferenceFilterInput,
): PreferenceFilters => {
  const grades = preference.grades
    .map((grade) => CORE_TO_CONNECT_GRADE[grade])
    .filter((grade): grade is GradeKey => grade !== undefined);

  return {
    address: preference.location,
    radius: resolveRadius(preference.milesWithin),
    grades,
    subjects: preference.subjects.filter(isValidSubjectKey),
  };
};
